module.exports = function getResource(label, vars) {
    const resources = {
        editLinkText: 'Modifier',
        subTitle: 'Expédition standard – GRATUITE',
        title: 'Shipping',
        autoReplenTitle: 'Shipping'
    };

    return resources[label];
};
